import React, {useEffect, useState} from 'react'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import '../revamp-offline-ops/revamp-react-table.css';
import {
  UncontrolledTooltip,
} from 'reactstrap';
import moment from 'moment';
import LoadingComponent from '../common/LoadingComponent';
import ReactTable from 'react-table';
import { getOrders, getUserPresDetailsFromPhone, uploadPharmacyPrescription, bookUserPharmacyOrder,getApprovalRequiredOrder } from '../../services/api/get-pharmacy-orders';
import { debounce } from '../../utils/debounce';
import { toast } from 'react-toastify';
import ReactTableInputFilter from './ReactTableInputFilter';
import { useCallback } from 'react';
import { convertToOpdConsult } from '../../services/api/get-labs-orders';
import Select from "react-select";
import StarPharmacyOrder from './StarPharmacyOrder';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
} from 'reactstrap';
import { CSVLink } from "react-csv";
import reactDom from 'react-dom';

import FoldableTableHOC from 'react-table/lib/hoc/foldableTable';
import SubComponent from './table-subcomponent/SubComponent';
import RetryOrder from './RetryOrder';
import WalletCoverageModal from './WalletCoverageModal';
import { cancelAndRefundOrder, downloadPHOrdersCsv, getpharmacyOrderCount, getpharmacyOrders, getOpsUserRole, retryDigitizeAndBookCartsGeneration } from './UploadRxComponents/Services';
import OrderTrackDetailModal from './OrderTrackDetailModal';
import DelayedOrderListModal from './DelayedOrderListModal';
import PharmacyActions from './PharmacyActions/index';
import FetchFollowUpRequestsModal from './FetchFollowUpRequestsModal';
import { pharmacyOpsActions} from '../../constant';
import GetCartsByMobileNo from './SearchAndBookModel';
import FixFailedOrderModal from './FixFailedOrderModal';

import PharmacyUserDashboard from './PharmacyUserDashboard';
import GenerateLocalPharmacyOrder from './GenerateLocalPharmacyOrder';

const FoldableTable = FoldableTableHOC(ReactTable);

const BRAND = '#6C5DD3';
const BRAND_LIGHT = '#F5F4FF';
const BRAND_BORDER = '#E5E9FE';
const DANGER = '#EB5757';
const DANGER_LIGHT = '#FFF0F0';
const TEXT_PRIMARY = '#0F0B28';
const TEXT_SECONDARY = '#585969';
const TEXT_MUTED = '#A5A6BB';
const SURFACE = '#FFFFFF';
const BORDER = '#E3E3E3';

const styles = {
  panel: {
    background: SURFACE,
    border: `1px solid ${BORDER}`,
    borderRadius: '8px',
    boxShadow: '0px 2px 8px rgba(0,0,0,0.06)',
    marginTop: '16px',
    overflow: 'hidden',
  },
  panelSection: {
    padding: '12px 16px',
  },
  sectionLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.4px',
    color: BRAND,
    borderRadius: '4px',
    padding: '3px 10px',
    marginBottom: '10px',
  },
  divider: {
    borderTop: `1px solid ${BORDER}`,
    margin: 0,
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '8px',
  },
  inputGroup: {
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    height: '32px',
    padding: '0 10px',
    fontSize: '13px',
    border: `1px solid ${BORDER}`,
    borderRight: 'none',
    borderRadius: '4px 0 0 4px',
    outline: 'none',
    color: TEXT_PRIMARY,
    background: '#FAFAFA',
    width: '130px',
    transition: 'border-color 0.15s',
  },
  inputAttached: {
    borderRadius: '0 4px 4px 0',
    height: '32px',
    padding: '0 12px',
    fontSize: '12px',
    fontWeight: 600,
    border: `1px solid ${BRAND}`,
    background: BRAND,
    color: '#fff',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background 0.15s',
  },
  inputAttachedDanger: {
    borderRadius: '0 4px 4px 0',
    height: '32px',
    padding: '0 12px',
    fontSize: '12px',
    fontWeight: 600,
    border: `1px solid ${DANGER}`,
    background: DANGER,
    color: '#fff',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  btn: {
    height: '32px',
    padding: '0 14px',
    fontSize: '12px',
    fontWeight: 600,
    borderRadius: '4px',
    cursor: 'pointer',
    border: `1px solid ${BRAND}`,
    background: BRAND,
    color: '#fff',
    whiteSpace: 'nowrap',
    transition: 'opacity 0.15s',
  },
  btnOutline: {
    height: '32px',
    padding: '0 14px',
    fontSize: '12px',
    fontWeight: 600,
    borderRadius: '4px',
    cursor: 'pointer',
    border: `1px solid ${BRAND_BORDER}`,
    background: BRAND_LIGHT,
    color: BRAND,
    whiteSpace: 'nowrap',
  },
  btnDanger: {
    height: '32px',
    padding: '0 14px',
    fontSize: '12px',
    fontWeight: 600,
    borderRadius: '4px',
    cursor: 'pointer',
    border: `1px solid ${DANGER}`,
    background: DANGER_LIGHT,
    color: DANGER,
    whiteSpace: 'nowrap',
  },
  btnWarning: {
    height: '32px',
    padding: '0 14px',
    fontSize: '12px',
    fontWeight: 600,
    borderRadius: '4px',
    cursor: 'pointer',
    border: '1px solid #F0A500',
    background: '#FFFBF0',
    color: '#B07800',
    whiteSpace: 'nowrap',
  },
  btnGhost: {
    height: '32px',
    padding: '0 14px',
    fontSize: '12px',
    fontWeight: 600,
    borderRadius: '4px',
    cursor: 'pointer',
    border: `1px solid ${BORDER}`,
    background: 'transparent',
    color: TEXT_SECONDARY,
    whiteSpace: 'nowrap',
  },
  statCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    background: BRAND_LIGHT,
    border: `1px solid ${BRAND_BORDER}`,
    borderRadius: '6px',
    padding: '6px 14px',
  },
  statLabel: {
    fontSize: '11px',
    color: TEXT_SECONDARY,
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  statValue: {
    fontSize: '22px',
    fontWeight: 700,
    color: BRAND,
    lineHeight: 1,
  },
  userCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    background: BRAND_LIGHT,
    border: `1px solid ${BRAND_BORDER}`,
    borderRadius: '6px',
    padding: '6px 12px',
  },
}

const flexibleDiv = styles.row
const actionGroup = styles.inputGroup

function PharmacyOrdersTable({ startDate, endDate, startDateDelivered, endDateDelivered, phone, showUploadPrescriptionModal, showAddApolloMedicineModal, showRefundOrderModal, showRefundBankAmountModal }) {
    const [loading, setLoading] = useState(false); 
    const [pageSize, setPageSize] = useState(50);
    const [pages, setPages] = useState(-1);
    const [filtered, setFiltered] = useState([]);
    const [allStatus, setAllStatus] =  useState(['Placed', 'Sample Collected', 'Completed', 'Cancelled']);
    const [sorted, setSorted] = useState([]);
    const [page, setPage] = useState(0);
    const [orders, setOrders] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [userPhone, setUserPhone] = useState(null);
    const [presAddress, setPresAddress] = useState(null);
    const [presPatients, setPresPatients] = useState(null);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [selectedAddress, setSelectedAddress]= useState(null);
    const [userAuthToken, setUserAuthToken] = useState(null);
    const [pharmacyPrescriptionId, setPharmacyPrescriptionId] = useState(null);
    const [ uploadDisabled,setUploadDisabled] = useState(false);
    const [count,setCount]= useState(0);
    const [openStarOrdersModal,setOpenStarOrdersModal] = useState(false);
    const [requiredApprovalOrderCount,setRequiredApprovalOrderCount] = useState(0);
    const [starOrderCancelationReasons, setStarOrderCancelationReasons] = useState([]);
    const [requiredApprovalData,setRequiredApprovalData]= useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [digitisationId , setDigitisationId] = useState('')
    const [cartId , setCartId] = useState(null);
    const [showPlaceOrderModal , setShowPlaceOrderModal] = useState(false);
    const [showWalletCoverage, setShowWalletCoverage] = useState(false);
  const [showTrackOrderDetail, setShowTrackOrderDetail] = useState(false);
  const [showLocalPharmacyModal, setShowLocalPharmacyModal] = useState(false);
  const [showDelayedOrderListModal, setShowDelayedOrderListModal] = useState(false);
  const [showSearchAndBookCart, setShowSearchAndBookCart] = useState(false);
  const [showFixFailedOrderModal, setShowFixFailedOrderModal] = useState(false);


    const [showPharmacyUserHomeDashboard, setShowPharmacyUserHomeDashboard] = useState(false);
    const [showFetchFollowUpModal , setShowFetchFollowUpModal] = useState(false);
    const [orderIdForFollowUp, setOrderIdForFollowUp] = useState(null);
    const [walletDigId, setWalletDigId] = useState('');
    const [orderIdToGetTrackOrderDetail, setOrderIdToGetTrackOrderDetail] = useState('');
    const [phoneToGetPharmacyUserHomeDashboard, setPhoneToGetPharmacyUserHomeDashboard] = useState('');
    const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);
    const [countLoading, setCountLoading] = useState(false)
    const [actionModal, setActionModal] = useState({
        orderId: null,
        isOpen: false,
        actionName: null,
        status: null,
        actionType: null,
        collectionDate: null,
        slotId: null,
      });
    const [orderIdToBeCancelled, setOrderIdToBeCancelled] = useState('');
    const [digitisationRequestIdForCartGeneration, setDigitisationRequestIdForCartGeneration] = useState('');
    const [opsRole, setOpsRole] = useState(null);  
    const [allowedActions, setAllowedActions] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState(orders);
    const [showVipOrdersOnly, setShowVipOrdersOnly] = useState('');

    const getUserDetailsForPrescriptionFromPhone = () => {
      console.log('Clicked');
      if(userPhone === null){
        toast.error('Please Enter Valid Phone');
      }
      if(userPhone !== null){
      getUserPresDetailsFromPhone(userPhone).then(response=>{
        console.log(response);
          if(response.status === 'Success'){
            setPresAddress(response.addressDetails);
            setPresPatients(response.patientDetails);
            setUserAuthToken(response.userAuth);
            toast.success(response.message);
          }
          else if (response.status === 'serverError'){
            toast.error(response.message);
          }
      });
    }
    }

  const EnterprisePagination = ({
    page, pages, pageSize, pageSizeOptions,
    canPrevious, canNext, onPageChange, onPageSizeChange,
  }) => {
    const [jumpValue, setJumpValue] = React.useState(page + 1);

    React.useEffect(() => { setJumpValue(page + 1); }, [page]);

    const goTo = (p) => {
      const target = Math.max(0, Math.min(pages - 1, p));
      onPageChange(target);
    };

    const btnBase = {
      height: '30px', minWidth: '30px', padding: '0 10px',
      fontSize: '12px', fontWeight: 600, borderRadius: '4px',
      cursor: 'pointer', border: `1px solid ${BORDER}`,
      background: SURFACE, color: TEXT_SECONDARY,
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      transition: 'all 0.15s',
    };
    const btnDisabled = { ...btnBase, opacity: 0.35, cursor: 'not-allowed' };
    const btnActive = { ...btnBase, background: BRAND, color: '#fff', borderColor: BRAND };

    // Build page window: show up to 5 page numbers around current
    const getPageNums = () => {
      const total = pages;
      if (total <= 7) return Array.from({ length: total }, (_, i) => i);
      const cur = page;
      const nums = new Set([0, total - 1]);
      for (let i = Math.max(0, cur - 1); i <= Math.min(total - 1, cur + 1); i++) nums.add(i);
      return Array.from(nums).sort((a, b) => a - b);
    };

    const pageNums = getPageNums();

    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexWrap: 'wrap', gap: '8px',
        padding: '10px 16px', borderTop: `1px solid ${BORDER}`,
        background: SURFACE,
      }}>
        {/* Left: page size selector */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '12px', color: TEXT_MUTED, whiteSpace: 'nowrap' }}>Rows per page</span>
          <select
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            style={{
              height: '30px', padding: '0 8px', fontSize: '12px',
              border: `1px solid ${BORDER}`, borderRadius: '4px',
              background: SURFACE, color: TEXT_PRIMARY, cursor: 'pointer', outline: 'none',
            }}
          >
            {(pageSizeOptions || [10, 20, 50, 100]).map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>

        {/* Center: page numbers */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <button style={canPrevious ? btnBase : btnDisabled} disabled={!canPrevious} onClick={() => goTo(page - 1)}>‹ Prev</button>

          {pageNums.map((p, i) => {
            const prev = pageNums[i - 1];
            const showEllipsis = prev !== undefined && p - prev > 1;
            return (
              <React.Fragment key={p}>
                {showEllipsis && (
                  <span style={{ fontSize: '12px', color: TEXT_MUTED, padding: '0 4px' }}>…</span>
                )}
                <button
                  style={p === page ? btnActive : btnBase}
                  onClick={() => goTo(p)}
                >{p + 1}</button>
              </React.Fragment>
            );
          })}

          <button style={canNext ? btnBase : btnDisabled} disabled={!canNext} onClick={() => goTo(page + 1)}>Next ›</button>
        </div>

        {/* Right: jump to page + total info */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '12px', color: TEXT_MUTED, whiteSpace: 'nowrap' }}>Go to</span>
          <input
            type="number" min={1} max={pages}
            value={jumpValue}
            onChange={(e) => setJumpValue(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') goTo(Number(jumpValue) - 1); }}
            onBlur={() => goTo(Number(jumpValue) - 1)}
            style={{
              width: '52px', height: '30px', padding: '0 8px', fontSize: '12px', textAlign: 'center',
              border: `1px solid ${BORDER}`, borderRadius: '4px',
              background: SURFACE, color: TEXT_PRIMARY, outline: 'none',
            }}
          />
          <span style={{ fontSize: '12px', color: TEXT_MUTED, whiteSpace: 'nowrap' }}>of <b style={{ color: TEXT_PRIMARY }}>{pages}</b> pages</span>
        </div>
      </div>
    );
  };

  const STATUS_STYLE = {
    Delivered:  { bg: '#EDFAF4', color: '#1eb865' },
    Completed:  { bg: '#EDFAF4', color: '#1eb865' },
    Placed:     { bg: '#E5E9FE', color: '#6C5DD3' },
    Billed:     { bg: '#E5E9FE', color: '#6C5DD3' },
    Pending:    { bg: '#FFF3DC', color: '#B07800' },
    Delayed:    { bg: '#FFF3DC', color: '#B07800' },
    Cancelled:  { bg: '#FFF0F0', color: '#EB5757' },
    Failed:     { bg: '#FFF0F0', color: '#EB5757' },
  };

  const StatusBadge = ({ value }) => {
    const s = STATUS_STYLE[value] || { bg: '#F0F0F0', color: '#585969' };
    return (
      <span style={{ background: s.bg, color: s.color, fontSize: '11px', fontWeight: 700, borderRadius: '4px', padding: '2px 8px', whiteSpace: 'nowrap' }}>
        {value || '—'}
      </span>
    );
  };

  const Pill = ({ label, bg = '#E5E9FE', color = '#6C5DD3' }) => (
    <span style={{ background: bg, color, fontSize: '11px', fontWeight: 600, borderRadius: '4px', padding: '2px 7px', whiteSpace: 'nowrap' }}>
      {label}
    </span>
  );

  const colHeaderStyle = {
    background: '#F7F8FA',
    display: 'flex',
    alignItems: 'center',
    padding: '0 10px',
    whiteSpace: 'normal',   // override CSS white-space: nowrap so headers wrap
    overflow: 'visible',
  };

  // Renders enterprise-style header text (overrides the CSS font rules on .rt-resizable-header-content)
  const H = (label) => () => (
    <span style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.55px', textTransform: 'uppercase', color: TEXT_SECONDARY, whiteSpace: 'normal', lineHeight: '1.3' }}>
      {label}
    </span>
  );

  const getColumns = () => [
    {
      Header: H('Order ID'),
      headerStyle: colHeaderStyle,
      width: 115,
      accessor: 'orderId',
      filterable: true,
      Filter: ReactTableInputFilter,
      Cell: (row) => {
        const { orderId } = row.original;
        const isVip = row.original.isVipUserOrder;
        const rowColor = row.original.color;
        return (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '3px', padding: '2px 0' }}>
            <Link
              target="_blank"
              to={`/new-pharmacy-order-details?orderId=${orderId}`}
              style={{ color: '#6C5DD3', fontWeight: 700, fontSize: '13px', textDecoration: 'none' }}
            >
              #{orderId}
            </Link>
            {!!isVip && <Pill label="⭐ VIP" bg="#FFF3DC" color="#B07800" />}
            {rowColor && rowColor !== 'transparent' && (
              <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: rowColor, display: 'inline-block' }} />
            )}
          </div>
        );
      },
    },
    {
      Header: H('TAT (hrs)'),
      headerStyle: colHeaderStyle,
      width: 80,
      accessor: 'etaInHour',
      filterable: true,
      Filter: ReactTableInputFilter,
      Cell: (row) => row.value != null
        ? <span style={{ fontWeight: 600, color: '#0F0B28' }}>{row.value}h</span>
        : <span style={{ color: '#A5A6BB' }}>—</span>,
    },
    {
      Header: H('Partner Order ID'),
      headerStyle: colHeaderStyle,
      width: 115,
      accessor: 'partnerBookingId',
      filterable: true,
      Filter: ReactTableInputFilter,
      Cell: (row) => <span style={{ fontSize: '12px', color: '#585969' }}>{row.value || '—'}</span>,
    },
    {
      Header: H('User Name'),
      headerStyle: colHeaderStyle,
      width: 110,
      accessor: 'userName',
      Cell: (row) => <span style={{ fontWeight: 500 }}>{row.value || '—'}</span>,
    },
    {
      Header: H('Patient Name'),
      headerStyle: colHeaderStyle,
      width: 110,
      accessor: 'patientName',
      Cell: (row) => <span style={{ fontWeight: 500 }}>{row.value || '—'}</span>,
    },
    {
      Header: H('Booking Date'),
      headerStyle: colHeaderStyle,
      width: 105,
      accessor: 'bookedOn',
      Cell: (row) => <span style={{ fontSize: '12px', color: '#585969' }}>{row.value || '—'}</span>,
    },
    {
      Header: H('Delivered Date'),
      headerStyle: colHeaderStyle,
      width: 105,
      accessor: 'deliveredDate',
      Cell: (row) => <span style={{ fontSize: '12px', color: '#585969' }}>{row.value || '—'}</span>,
    },
    {
      Header: H('Billed Date'),
      headerStyle: colHeaderStyle,
      width: 105,
      accessor: 'BilledAt',
      Cell: (row) => <span style={{ fontSize: '12px', color: '#585969' }}>{row.value || '—'}</span>,
    },
    {
      Header: H('Cancelled Date'),
      headerStyle: colHeaderStyle,
      width: 105,
      accessor: 'CancelledDate',
      Cell: (row) => <span style={{ fontSize: '12px', color: '#585969' }}>{row.value || '—'}</span>,
    },
    {
      Header: H('Partner'),
      headerStyle: colHeaderStyle,
      width: 110,
      accessor: 'partnerName',
      filterable: true,
      Filter: ReactTableInputFilter,
      Cell: (row) => row.value ? <Pill label={row.value} bg="#F5F4FF" color="#6C5DD3" /> : <span style={{ color: '#A5A6BB' }}>—</span>,
    },
    {
      Header: H('Sponsor'),
      headerStyle: colHeaderStyle,
      width: 110,
      accessor: 'sponsorName',
      filterable: true,
      Filter: ReactTableInputFilter,
      Cell: (row) => <span style={{ fontSize: '12px' }}>{row.value || '—'}</span>,
    },
    {
      Header: H('Status'),
      headerStyle: colHeaderStyle,
      width: 110,
      accessor: 'status',
      filterable: true,
      filterMethod: (filter, row) => filter.value === 'all' ? true : row.status === filter.value,
      Filter: ({ filter, onChange }) => (
        <select onChange={(e) => onChange(e.target.value)} style={{ width: '100%' }} value={filter ? filter.value : 'all'}>
          <option value="all">All</option>
          <option value="Delayed">Delayed</option>
          <option value="Delivered">Delivered</option>
          <option value="Placed">Placed</option>
          <option value="Cancelled">Cancelled</option>
          <option value="Billed">Billed</option>
          <option value="Pending">Pending</option>
          <option value="Failed">Failed</option>
        </select>
      ),
      Cell: (row) => <StatusBadge value={row.value} />,
    },
    {
      Header: H('State'),
      headerStyle: colHeaderStyle,
      width: 90,
      accessor: 'state',
      filterable: true,
      Filter: ReactTableInputFilter,
      Cell: (row) => <span style={{ fontSize: '12px', color: '#585969' }}>{row.value || '—'}</span>,
    },
    {
      Header: H('Order Type'),
      headerStyle: colHeaderStyle,
      width: 100,
      accessor: 'orderType',
      Cell: (info) => info.value
        ? <Pill label={info.value.toUpperCase()} bg="#F5F4FF" color="#6C5DD3" />
        : <span style={{ color: '#A5A6BB' }}>—</span>,
    },
    {
      Header: H('Source Type'),
      headerStyle: colHeaderStyle,
      width: 130,
      accessor: 'sourceType',
      Cell: (info) => {
        const { sourceType, orderSponserType } = info.original;
        let label = sourceType || '';
        if (sourceType === 'uploaded-prescription') label = 'DIGITIZE & BOOK';
        else if (sourceType === 'search') label = orderSponserType || 'SEARCH';
        return label ? <Pill label={label.toUpperCase()} bg="#EFF6FF" color="#0049C6" /> : <span style={{ color: '#A5A6BB' }}>—</span>;
      },
    },
    {
      Header: H('Tags'),
      headerStyle: colHeaderStyle,
      width: 160,
      accessor: 'tags',
      filterable: true,
      filterMethod: (filter, row) => filter.value === 'all' ? true : row.status === filter.value,
      Cell: (info) => {
        const followUpCount = info.original?.followUpCount;
        const deliveryStatus = info.original?.deliveryStatus;
        if (!followUpCount && !['order_received', 'order_not_received'].includes(deliveryStatus)) return null;
        return (
          <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
            {followUpCount && (
              <span
                style={{ background: '#FFF3DC', color: '#B07800', fontSize: '11px', fontWeight: 600, borderRadius: '4px', padding: '2px 7px', cursor: 'pointer' }}
                onClick={() => setOrderIdForFollowUp(info.original.orderId)}
              >
                📅 Scheduled ({followUpCount})
              </span>
            )}
            {deliveryStatus === 'order_received' && <Pill label="✓ Delivered" bg="#EDFAF4" color="#1eb865" />}
            {deliveryStatus === 'order_not_received' && <Pill label="✗ Not Delivered" bg="#FFF0F0" color="#EB5757" />}
          </div>
        );
      },
      Filter: ({ filter, onChange }) => (
        <select onChange={(e) => onChange(e.target.value)} style={{ width: '100%' }} value={filter ? filter.value : 'all'}>
          <option value="all">All</option>
          <option value="followup-pending">Pending Follow Up</option>
          <option value="order_received">Delivered</option>
          <option value="order_not_received">Not Delivered</option>
        </select>
      ),
    },
    {
      Header: H('Cancelled By'),
      headerStyle: colHeaderStyle,
      width: 105,
      accessor: 'cancelledBy',
      filterable: true,
      filterMethod: (filter, row) => filter.value === 'all' ? true : row.status === filter.value,
      Filter: ({ filter, onChange }) => (
        <select onChange={(e) => onChange(e.target.value)} style={{ width: '100%' }} value={filter ? filter.value : 'all'}>
          <option value="all">All</option>
          <option value="USER">User</option>
          <option value="PARTNER">Partner</option>
          <option value="OPS">Ops</option>
        </select>
      ),
      Cell: (row) => row.value ? <Pill label={row.value} bg="#FFF0F0" color="#EB5757" /> : <span style={{ color: '#A5A6BB' }}>—</span>,
    },
    {
      Header: H('Max Delivery'),
      headerStyle: colHeaderStyle,
      width: 105,
      accessor: 'maxDeliveryDate',
      Cell: (row) => <span style={{ fontSize: '12px', color: '#585969' }}>{row.value || '—'}</span>,
    },
    {
      Header: H('Min Delivery'),
      headerStyle: colHeaderStyle,
      width: 105,
      accessor: 'minDeliveryDate',
      Cell: (row) => <span style={{ fontSize: '12px', color: '#585969' }}>{row.value || '—'}</span>,
    },
    {
      Header: H('Delivery Type'),
      headerStyle: colHeaderStyle,
      width: 105,
      accessor: 'orderDeliveryType',
      Cell: (row) => row.value ? <Pill label={row.value} bg="#F5F4FF" color="#6C5DD3" /> : <span style={{ color: '#A5A6BB' }}>—</span>,
    },
    {
      Header: H('Platform'),
      headerStyle: colHeaderStyle,
      width: 95,
      accessor: 'platform',
      Cell: (row) => row.value ? <Pill label={row.value} bg="#F0F3F6" color="#585969" /> : <span style={{ color: '#A5A6BB' }}>—</span>,
    },
    {
      Header: () => (
        <span style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.55px', textTransform: 'uppercase', color: BRAND, whiteSpace: 'normal', lineHeight: '1.3' }}>
          Actions
        </span>
      ),
      filterable: false,
      accessor: 'actions',
      width: 110,
      style: {
        position: 'sticky',
        right: 0,
        background: '#fff',
        zIndex: 2,
        boxShadow: '-2px 0 6px rgba(0,0,0,0.06)',
        overflow: 'visible',
      },
      headerStyle: {
        ...colHeaderStyle,
        position: 'sticky',
        right: 0,
        background: '#F5F4FF',
        justifyContent: 'center',
        zIndex: 2,
        color: '#6C5DD3',
        boxShadow: '-2px 0 6px rgba(0,0,0,0.06)',
      },
      Cell: (row) => (
        <div style={{ overflow: 'visible', display: 'flex', justifyContent: 'center' }}>
          <PharmacyActions orderId={row.original.orderId} allowedActions={allowedActions} />
        </div>
      ),
    }
    
  ];


  const prepareApiFilters = useCallback(() => {
    const appliedFilters = {};
    // let appliedOrderBy = {};
    // Convert this list of filterables into object properties
    filtered.forEach(
      (filter) => (appliedFilters[filter.id] = filter.value)
    );

    appliedFilters.rowsPerPage = pageSize;
    appliedFilters.page = page + 1;
    appliedFilters.phone = phone ? phone : '';
    appliedFilters.deliveredFrom = startDateDelivered && endDateDelivered ? moment(startDateDelivered).format("YYYY-MM-DD 00:00:00") : '';
    appliedFilters.deliveredTo = endDateDelivered && startDateDelivered ? moment(endDateDelivered).format("YYYY-MM-DD 23:59:59") : '';
    appliedFilters.bookingFrom = startDate && endDate ? moment(startDate).format("YYYY-MM-DD 00:00:00") : '';
    appliedFilters.bookingTo = endDate && startDate ? moment(endDate).format("YYYY-MM-DD 23:59:59") : '';
    appliedFilters.showVipOrdersOnly = showVipOrdersOnly ? 1 : '';
    return appliedFilters;

  }, [filtered, pageSize, page, phone, startDateDelivered, endDateDelivered, startDate, endDate, showVipOrdersOnly]);


    
 const updateStateFilters = (id, value, id2, value2) => {
    console.log('Update all filters in state', { id, value, id2, value2 });
    // console.log('New filter values', moment(value).format('DD-MM-YYYY'), moment(value2).format('DD-MM-YYYY'));
    const filter = filtered.find((f) => f.id === id);
    const filter2 = filtered.find((f) => f.id === id2);
    if (filter) {
      filter.value = value;
    } else {
      setFiltered([...filtered, {id,value}]);
    }
    if (filter2) {
      filter2.value = value2;
      setFiltered([...filtered, {id,value}]);
    } else {
      setFiltered([...filtered, { id: id2, value: value2 }]);
    }
  };

  const onFilteredChange = (e) => {
    // to be debounced
    setFiltered(e)
  };
    

    const  fetchOrders = useCallback(() => {
        setLoading(true);
        const appliedFilters = prepareApiFilters();
        getOrders(appliedFilters, sorted)
            .then((response) => {
            console.log('Api response', response.body);
            const pages =  Math.ceil (response.body.count / pageSize)
            // const pages =
            //     response.body.count % appliedFilters.rowsPerPage === 0
            //     ? parseInt(response.body.count / appliedFilters.rowsPerPage)
            //     : parseInt(response.body.count / appliedFilters.rowsPerPage) + 1;

                // setOrders(response.body.orders);
                setFilteredOrders(response.body.orders);
                setLoading(false);
                setPages(pages);
                setCount(response.body.count)
                //setIsAdmin(response.body.isAdmin === 1 ? true : false)
            })
            .catch((err) => {
            console.error(err, 'Error in get labs orders API');
            toast.error(`Error in fetching orders`);
            });
        }, [pageSize, prepareApiFilters, sorted]);

    const getOrders = useCallback(async () => {
      setLoading(true);
    
      const appliedFilters = prepareApiFilters();
    
      try {
        const [userRole, ordersResp] = await Promise.all([
          getOpsUserRole(),
          getpharmacyOrders(appliedFilters, sorted)
        ]);
    
        if (userRole.userRole != "NA" && userRole.allowedActions) {
          setIsAdmin(userRole.userRole != "NA");
          setOpsRole(userRole.userRole);
          setAllowedActions(userRole.allowedActions);
        }

        
        
        if (Array.isArray(ordersResp)) {
          setFilteredOrders(ordersResp);
        } else {
          toast.error('Failed to fetch orders');
          setFilteredOrders([]);
        }
      } catch (err) {
        toast.error('Error fetching orders');
        setFilteredOrders([]);
      } finally {
        setLoading(false);
      }
    
      fetchOrderCount(appliedFilters);
    }, [pageSize, prepareApiFilters, sorted, isAdmin]);
    
    const fetchOrderCount = async (appliedFilters) => {
      setCountLoading(true);
    
      try {
        const countResp = await getpharmacyOrderCount(appliedFilters);
    
        if (typeof countResp === 'number') {
          const pages = Math.ceil(countResp / pageSize);
          setPages(prev => (prev !== pages ? pages : prev));
          setCount(prev => (prev !== countResp ? countResp : prev));
        } else {
          toast.error('Failed to fetch order count');
          setPages(0);
          setCount(0);
        }
      } catch (err) {
        toast.error('Failed to fetch order count');
        setPages(0);
        setCount(0);
      } finally {
        setCountLoading(false);
      }
    };
        
        
    useEffect(()=>{
      getOrders();
    }, [getOrders]);

    const OpenModal = ()=>{ 
      setOpenStarOrdersModal(true);
    }
    const getOrdersForApprovals =useCallback(() => {
      getApprovalRequiredOrder()
      .then((res)=>{
      if(res.count>0){
        setRequiredApprovalOrderCount(res.count);
        setRequiredApprovalData(res.orders );
        setStarOrderCancelationReasons(res.cancelationReasons);
         
      }
      }).catch((err)=>{
        console.log(err );
      })
    },[]);
    
    //getOrdersForApprovals();
    useEffect(()=>{
      getOrdersForApprovals();
    },[getOrdersForApprovals])

    //Handle Phone Search
    // useEffect(()=>{
    //     if(phone !== null){
    //         const tempList = orders.filter((order) => {
    //             return (
    //                 order.patientPhone.toString().toLowerCase().indexOf(phone.toLowerCase()) !==
    //                 -1
    //             );
    //           });
    //           setFilteredOrders(tempList);
    //     }
    // }, [orders, phone]);

    useEffect(()=>{
      
    }, [userAuthToken, userPhone]);

    const placeOrder = () => {
    }

    const handleSelectedAddressChange = (address) => {
      setSelectedAddress(address);
    }

    const handleSelectedPatientChange = (patient) => {
      setSelectedPatient(patient);
    }

    const addPrescriptionFile = () => {
      document.querySelector('#add-prescription-input').click();
    };

    const onPrescriptionFileAdded = () => {
      const file = document.querySelector('#add-prescription-input').files[0];
      console.log('datat phone',userPhone)
      const toastId = toast('Uploading', {
        position: 'top-center',
        closeButton: false,
        closeOnClick: false,
        hideProgressBar: false,
        type: toast.TYPE.INFO,
        progress: 0,
      });
      const onUploadProgress = (progressEvent) => {
        if (progressEvent.lengthComputable) {
          const { loaded, total } = progressEvent;
          toast.update(toastId, {
            progress: loaded / total,
          });
        }
      };
      if(file){
        setUploadDisabled(true);
    return   uploadPharmacyPrescription(file, userPhone, onUploadProgress, userAuthToken).then(response=>{
        console.log(response, 'Pharmacy Prescription Id');
        if(response.message === 'success'){
          toast.success('Successfully Uploaded');
        setUploadDisabled(false);
        }
        setPharmacyPrescriptionId(response);
      })
    }
    }
    const handleDigitisationInput = (e) => {
      const value = e.target.value;
  
      // Remove any non-numeric characters
      const formattedValue = value.replace(/[^0-9]/g, '');
  
      // Update the state with the formatted value
      setDigitisationId(formattedValue);
    };
   const fetchStrategy = (state) => this.fetchDataWithDebounce(state);

   const handleShowWalletCoverageDetails = (e) => {
    const value = e.target.value;

    // Remove any non-numeric characters
    const formattedValue = value.replace(/[^0-9]/g, '');

    // Update the state with the formatted value
    setWalletDigId(formattedValue);
  };
  const handlecartIdInput = (e) => {
    const value = e.target.value;

    const formattedValue = value.replace(/[^0-9]/g, '');

    setCartId(formattedValue);
  }

  const handleShowTrackOrderDetails = (e) => {
    const value = e.target.value;

    // Remove any non-numeric characters
    const formattedValue = value.replace(/[^0-9]/g, '');

    // Update the state with the formatted value
    setOrderIdToGetTrackOrderDetail(formattedValue);
  };

  const handleShowPharmacyDashboardSummary = (e) => {
    const value = e.target.value;

    // Remove any non-numeric characters
    const formattedValue = value.replace(/[^0-9]/g, '');

    // Update the state with the formatted value
    setPhoneToGetPharmacyUserHomeDashboard(formattedValue);
  };

    const bookUserPharmacyOrderButton = () => {
      return bookUserPharmacyOrder(selectedAddress.value, selectedPatient.value, pharmacyPrescriptionId, userPhone).then(response=>{
        if(response.message==="success"){
          toast.success(response.showMessage);
          clearCurrentUser();
        }
        else{
          toast.error('Error in Uploading Digitisation');
        }
      });  
    }
    const downloadCsv = async()=> {
      const appliedFilters = prepareApiFilters();
      setIsDownloadingCsv(true);
      await downloadPHOrdersCsv(appliedFilters);
      setIsDownloadingCsv(false);
    }
    const handleOrderIdInput = (e) => {
      const value = e.target.value;
      const formattedValue = value.replace(/[^0-9]/g, '');
      setOrderIdToBeCancelled(formattedValue);
    };

  
  const handleRetryDigitizeAndBookCartsGeneration = (e) => {
      const value = e.target.value;
      const formattedValue = value.replace(/[^0-9]/g, '');
      setDigitisationRequestIdForCartGeneration(formattedValue);
    };

    const CancelAndRefundOrder = async() => {
      const response = await cancelAndRefundOrder(orderIdToBeCancelled);
      alert(response.message);
    }
  
  const RetryDigitizeAndBookCartsGeneration = async () => {
    const response = await retryDigitizeAndBookCartsGeneration(digitisationRequestIdForCartGeneration);
    alert(response.message);
  }

    const clearCurrentUser = () => {
      setPresAddress(null);
      setPresPatients(null);
      setSelectedPatient(null);
      setSelectedAddress(null);
      setUserPhone(null);
      setSelectedFile(null);
      setUserAuthToken(null);
      setPharmacyPrescriptionId(null);
      setShowVipOrdersOnly('');
    }

    const isActionAllowedForOpsRole = (action) => {
      if(opsRole && allowedActions.includes(action)) {
        return true;
      }
      return false;
    }
    
    
  return (
    <React.Fragment>

      {/* ── Action Panel ── */}
      <div style={styles.panel}>

        {/* Section 1 — Order Management */}
        <div style={styles.panelSection}>
          <div style={styles.sectionLabel}>⚙️ Order Management</div>
          <div style={styles.row}>

            {/* Cancel Order */}
            <div style={styles.inputGroup}>
              <input type="text" style={styles.input} placeholder="Order ID"
                onKeyDown={(e) => e.key === 'Enter' ? CancelAndRefundOrder() : null}
                onChange={handleOrderIdInput} value={orderIdToBeCancelled} />
              <button
                style={{ ...styles.inputAttachedDanger, opacity: orderIdToBeCancelled && isActionAllowedForOpsRole(pharmacyOpsActions.CANCEL_ORDER) ? 1 : 0.75, cursor: orderIdToBeCancelled && isActionAllowedForOpsRole(pharmacyOpsActions.CANCEL_ORDER) ? 'pointer' : 'not-allowed' }}
                disabled={!(orderIdToBeCancelled && isActionAllowedForOpsRole(pharmacyOpsActions.CANCEL_ORDER))}
                type="button" onClick={() => CancelAndRefundOrder()}
              >Cancel Order</button>
            </div>

            {/* Search & Book */}
            <div style={styles.inputGroup}>
              <input type="text" style={styles.input} placeholder="Cart ID"
                onKeyDown={(e) => e.key === 'Enter' ? setShowSearchAndBookCart(true) : null}
                onChange={handlecartIdInput} value={cartId} />
              <button
                style={{ ...styles.inputAttached, opacity: cartId && isActionAllowedForOpsRole(pharmacyOpsActions.GET_CARTS) ? 1 : 0.75, cursor: cartId && isActionAllowedForOpsRole(pharmacyOpsActions.GET_CARTS) ? 'pointer' : 'not-allowed' }}
                disabled={!(cartId && isActionAllowedForOpsRole(pharmacyOpsActions.GET_CARTS))}
                type="button" onClick={() => setShowSearchAndBookCart(true)}
              >Search &amp; Book</button>
            </div>

            {/* Get Carts */}
            <div style={styles.inputGroup}>
              <input type="text" style={styles.input} placeholder="Digi ID → Get Carts"
                onKeyDown={(e) => e.key === 'Enter' ? setShowPlaceOrderModal(true) : null}
                onChange={handleDigitisationInput} value={digitisationId} />
              <button
                style={{ ...styles.inputAttached, opacity: digitisationId && isActionAllowedForOpsRole(pharmacyOpsActions.GET_CARTS) ? 1 : 0.75, cursor: digitisationId && isActionAllowedForOpsRole(pharmacyOpsActions.GET_CARTS) ? 'pointer' : 'not-allowed' }}
                disabled={!(digitisationId && isActionAllowedForOpsRole(pharmacyOpsActions.GET_CARTS))}
                type="button" onClick={() => setShowPlaceOrderModal(true)}
              >Get Carts</button>
            </div>

            {/* Retry D&B */}
            <div style={styles.inputGroup}>
              <input type="text" style={{ ...styles.input, width: '120px' }} placeholder="Digi ID → Retry"
                onKeyDown={(e) => e.key === 'Enter' ? RetryDigitizeAndBookCartsGeneration() : null}
                onChange={handleRetryDigitizeAndBookCartsGeneration} value={digitisationRequestIdForCartGeneration} />
              <button
                style={{ ...styles.inputAttached, opacity: digitisationRequestIdForCartGeneration && isActionAllowedForOpsRole(pharmacyOpsActions.RETRY_DIGITIZE_AND_BOOK_CARTS_GENERATION) ? 1 : 0.75, cursor: digitisationRequestIdForCartGeneration && isActionAllowedForOpsRole(pharmacyOpsActions.RETRY_DIGITIZE_AND_BOOK_CARTS_GENERATION) ? 'pointer' : 'not-allowed' }}
                disabled={!(digitisationRequestIdForCartGeneration && isActionAllowedForOpsRole(pharmacyOpsActions.RETRY_DIGITIZE_AND_BOOK_CARTS_GENERATION))}
                type="button" onClick={() => RetryDigitizeAndBookCartsGeneration()}
              >Retry D&amp;B</button>
            </div>

            {/* Standalone buttons */}
            <button
              style={{ ...styles.btnOutline, opacity: isActionAllowedForOpsRole(pharmacyOpsActions.GENERATE_LOCAL_PHARMACY_ORDER) ? 1 : 0.75 }}
              disabled={!isActionAllowedForOpsRole(pharmacyOpsActions.GENERATE_LOCAL_PHARMACY_ORDER)}
              type="button" onClick={() => setShowLocalPharmacyModal(true)}
            >+ Local Order</button>

            <button
              style={{ ...styles.btnDanger, opacity: isActionAllowedForOpsRole(pharmacyOpsActions.FIX_FAILED_ORDER) ? 1 : 0.75 }}
              disabled={!isActionAllowedForOpsRole(pharmacyOpsActions.FIX_FAILED_ORDER)}
              type="button" onClick={() => setShowFixFailedOrderModal(true)}
            >🔧 Fix Failed Orders</button>

          </div>
        </div>

        <hr style={styles.divider} />

        {/* Section 2 — Lookup & Monitoring */}
        <div style={styles.panelSection}>
          <div style={styles.sectionLabel}>🔍 Lookup &amp; Monitoring</div>
          <div style={styles.row}>

            {/* Track Order */}
            <div style={styles.inputGroup}>
              <input type="text" style={styles.input} placeholder="Order ID"
                onKeyDown={(e) => e.key === 'Enter' ? setShowTrackOrderDetail(true) : null}
                onChange={handleShowTrackOrderDetails} value={orderIdToGetTrackOrderDetail} />
              <button
                style={{ ...styles.inputAttached, opacity: orderIdToGetTrackOrderDetail && isActionAllowedForOpsRole(pharmacyOpsActions.TRACK_ORDER) ? 1 : 0.75, cursor: orderIdToGetTrackOrderDetail && isActionAllowedForOpsRole(pharmacyOpsActions.TRACK_ORDER) ? 'pointer' : 'not-allowed' }}
                disabled={!(orderIdToGetTrackOrderDetail && isActionAllowedForOpsRole(pharmacyOpsActions.TRACK_ORDER))}
                type="button" onClick={() => setShowTrackOrderDetail(true)}
              >Track Order</button>
            </div>

            {/* User Dashboard */}
            <div style={styles.inputGroup}>
              <input type="text" style={{ ...styles.input, width: '140px' }} placeholder="Phone number"
                onKeyDown={(e) => e.key === 'Enter' ? setShowPharmacyUserHomeDashboard(true) : null}
                onChange={handleShowPharmacyDashboardSummary} value={phoneToGetPharmacyUserHomeDashboard} />
              <button
                style={{ ...styles.inputAttached, opacity: phoneToGetPharmacyUserHomeDashboard ? 1 : 0.75, cursor: phoneToGetPharmacyUserHomeDashboard ? 'pointer' : 'not-allowed' }}
                disabled={!phoneToGetPharmacyUserHomeDashboard}
                type="button" onClick={() => setShowPharmacyUserHomeDashboard(true)}
              >User Dashboard</button>
            </div>

            {/* Wallet Coverage */}
            <div style={styles.inputGroup}>
              <input type="text" style={styles.input} placeholder="Digi ID → Wallet"
                onKeyDown={(e) => e.key === 'Enter' ? setShowWalletCoverage(true) : null}
                onChange={handleShowWalletCoverageDetails} value={walletDigId} />
              <button
                style={{ ...styles.inputAttached, opacity: walletDigId && isActionAllowedForOpsRole(pharmacyOpsActions.GET_WALLET_COVERAGE) ? 1 : 0.75, cursor: walletDigId && isActionAllowedForOpsRole(pharmacyOpsActions.GET_WALLET_COVERAGE) ? 'pointer' : 'not-allowed' }}
                disabled={!(walletDigId && isActionAllowedForOpsRole(pharmacyOpsActions.GET_WALLET_COVERAGE))}
                type="button" onClick={() => setShowWalletCoverage(true)}
              >Wallet Coverage</button>
            </div>

            <button style={styles.btnWarning} type="button" onClick={() => setShowDelayedOrderListModal(true)}>
              🚨 Delayed Orders
            </button>

          </div>
        </div>

        <hr style={styles.divider} />

        {/* Section 2b — Finance & Export */}
        <div style={styles.panelSection}>
          <div style={styles.sectionLabel}>💰 Finance &amp; Export</div>
          <div style={styles.row}>

            <button
              style={{ ...styles.btnOutline, opacity: isActionAllowedForOpsRole(pharmacyOpsActions.REFUND_AMOUNT) ? 1 : 0.75 }}
              disabled={!isActionAllowedForOpsRole(pharmacyOpsActions.REFUND_AMOUNT)}
              onClick={showRefundOrderModal}
            >Refund Amount</button>

            <button style={styles.btnWarning} onClick={showRefundBankAmountModal}>
              Refund Bank Amount
            </button>

            <button
              style={{ ...styles.btnGhost, opacity: isActionAllowedForOpsRole(pharmacyOpsActions.DOWNLOAD_CSV) ? 1 : 0.75 }}
              onClick={downloadCsv}
              disabled={!isActionAllowedForOpsRole(pharmacyOpsActions.DOWNLOAD_CSV)}
            >{isDownloadingCsv ? '⏳ Downloading…' : '↓ Download CSV'}</button>

          </div>
        </div>

        <hr style={styles.divider} />

        {/* Section 3 — Stats & Controls */}
        <div style={{ ...styles.panelSection, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '12px', justifyContent: 'space-between' }}>

          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '10px' }}>
            {/* Stat chip */}
            <div style={styles.statCard}>
              <div>
                <div style={styles.statLabel}>Total Orders</div>
                {countLoading
                  ? <LoadingComponent color={BRAND} />
                  : <div style={styles.statValue}>{count || 0}</div>}
              </div>
            </div>

            <button
              style={{ ...styles.btnWarning, opacity: requiredApprovalOrderCount === 0 ? 0.45 : 1 }}
              onClick={OpenModal}
              disabled={requiredApprovalOrderCount === 0}
            >
              ⏳ Approval Pending &nbsp;
              <span style={{ background: '#B07800', color: '#fff', borderRadius: '10px', padding: '1px 7px', fontSize: '11px' }}>
                {requiredApprovalOrderCount}
              </span>
            </button>

            <button
              style={{ ...styles.btnOutline, opacity: isActionAllowedForOpsRole(pharmacyOpsActions.CHECK_VIP_USERS) ? 1 : 0.75 }}
              disabled={!isActionAllowedForOpsRole(pharmacyOpsActions.CHECK_VIP_USERS)}
              onClick={() => setShowVipOrdersOnly(1)}
            >
              ⭐ VIP Only
            </button>

            <button
              style={{ ...styles.btnOutline, opacity: isAdmin ? 1 : 0.75 }}
              disabled={!isAdmin}
              onClick={showAddApolloMedicineModal}
            >
              Add Apollo Medicine
            </button>

            <button
              style={{ ...styles.btnOutline, opacity: isActionAllowedForOpsRole(pharmacyOpsActions.UPLOAD_PRESCRIPTION) ? 1 : 0.75 }}
              disabled={!isActionAllowedForOpsRole(pharmacyOpsActions.UPLOAD_PRESCRIPTION)}
              onClick={showUploadPrescriptionModal}
            >
              Upload Prescription
            </button>
          </div>

          {presAddress && (
            <div style={styles.userCard}>
              <div>
                <div style={{ fontSize: '10px', color: TEXT_MUTED, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Active User</div>
                <div style={{ fontSize: '13px', fontWeight: 700, color: TEXT_PRIMARY }}>{userPhone}</div>
              </div>
              <button style={{ ...styles.btnDanger, padding: '0 10px', height: '28px', fontSize: '11px' }} type="button" onClick={clearCurrentUser}>
                Clear
              </button>
            </div>
          )}
        </div>

        {presAddress !== null && presPatients !== null && userAuthToken !== null && (
          <div style={{ ...styles.panelSection, borderTop: `1px solid ${BORDER}`, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '10px' }}>
            <div style={{ minWidth: '200px' }}>
              <Select options={presAddress} placeholder="Select Address" onChange={handleSelectedAddressChange} value={selectedAddress} />
            </div>
            <div style={{ minWidth: '200px' }}>
              <Select options={presPatients} placeholder="Select Patient" onChange={handleSelectedPatientChange} value={selectedPatient} />
            </div>
            <input
              type="file"
              id="add-prescription-input"
              accept=".png,.jpg,.jpeg,.pdf"
              style={{ display: 'none' }}
              onChange={onPrescriptionFileAdded}
            />
            {pharmacyPrescriptionId === null
              ? <button style={{ ...styles.btnOutline, opacity: uploadDisabled ? 0.45 : 1 }} onClick={addPrescriptionFile} disabled={uploadDisabled}>+ Add Prescription</button>
              : selectedAddress !== null && selectedPatient !== null
                ? <button style={{ ...styles.btn, background: '#1eb865', borderColor: '#1eb865' }} onClick={bookUserPharmacyOrderButton}>Place Order</button>
                : <span style={{ fontSize: '12px', color: TEXT_MUTED }}>Select address &amp; patient to continue</span>
            }
          </div>
        )}

      </div>

        <div style={{
          background: '#fff',
          border: '1px solid #E3E3E3',
          borderRadius: '8px',
          boxShadow: '0px 2px 8px rgba(0,0,0,0.06)',
          marginTop: '16px',
          overflow: 'hidden',
        }}>
          <FoldableTable
            keyField="orderId"
            data={filteredOrders}
            columns={getColumns()}
            defaultPageSize={50}
            pages={pages}
            pageSize={pageSize}
            page={page}
            loading={loading}
            filtered={filtered}
            sorted={sorted}
            manual
            SubComponent={(row) => (
              <SubComponent
                orderId={row.original.orderId}
                userId={row.original.userId}
              />
            )}
            onFilteredChange={onFilteredChange}
            onPageSizeChange={(pageSize) => setPageSize(pageSize)}
            onPageChange={(page) => setPage(page)}
            onSortedChange={(sorted) => setSorted(sorted)}
            className="-highlight revamp-table"
            showPaginationTop
            showPaginationBottom
            PaginationComponent={EnterprisePagination}
            getTheadGroupThProps={() => ({
              style: {
                fontSize: '11px',
                fontWeight: 700,
                letterSpacing: '0.55px',
                textTransform: 'uppercase',
                color: TEXT_SECONDARY,
                background: '#F7F8FA',
                borderBottom: `1px solid ${BORDER}`,
                display: 'flex',
                alignItems: 'center',
                padding: '0 10px',
              }
            })}
          />
        </div>
        <StarPharmacyOrder
          isOpen={openStarOrdersModal}
          tableSource={requiredApprovalData}
     getOrdersForApprovals = {getOrdersForApprovals}
     onClose = {()=>setOpenStarOrdersModal(false)}
     cancelationReasons = {starOrderCancelationReasons}

          
        ></StarPharmacyOrder>
          {showPlaceOrderModal && <RetryOrder digitisationId = {digitisationId} onClose ={()=> setShowPlaceOrderModal(false)} />}
      {showWalletCoverage && <WalletCoverageModal onClose={() => setShowWalletCoverage(false)} digitisationId={walletDigId} />}
      {showLocalPharmacyModal && <GenerateLocalPharmacyOrder onClose={() => setShowLocalPharmacyModal(false)} />}
      {showTrackOrderDetail && <OrderTrackDetailModal onClose={() => setShowTrackOrderDetail(false)} orderId={orderIdToGetTrackOrderDetail} />}
      {showDelayedOrderListModal && <DelayedOrderListModal onClose={() => setShowDelayedOrderListModal(false)} isOpen={showDelayedOrderListModal} />}
      {showFixFailedOrderModal && (
        <FixFailedOrderModal
          isOpen={true}
          onClose={() => setShowFixFailedOrderModal(false)}
        />
      )}
      {showPharmacyUserHomeDashboard && <PharmacyUserDashboard onClose={() => setShowPharmacyUserHomeDashboard(false)} phone={phoneToGetPharmacyUserHomeDashboard} />}
      {orderIdForFollowUp && <FetchFollowUpRequestsModal onClose = {() => setOrderIdForFollowUp(null)} orderId = { orderIdForFollowUp} />}  
      {showSearchAndBookCart && <GetCartsByMobileNo onClose = {()=> setShowSearchAndBookCart(false)} cartId = {cartId}/>}
      </React.Fragment>
      
      
  )
}

export default PharmacyOrdersTable